import { AudioSurah } from '../class/audio-surah';
import { routes } from '../const/routes';

interface IMusicRecordingMarkupSchemaParams {
  audioSurah: AudioSurah;
  reciterName: string;
  reciterSlug: string;
  url: string;
}

const musicRecordingMarkupSchema = ({
  audioSurah,
  reciterName,
  reciterSlug,
  url,
}: IMusicRecordingMarkupSchemaParams) => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  return {
    '@type': 'MusicRecording',
    '@id': `${url}#recording`,
    name: audioSurah.titleEn,
    url,
    byArtist: {
      '@type': 'Person',
      name: reciterName,
      url: `${SITE_URL}${routes.reciters}/${reciterSlug}`,
    },
    audio: {
      '@type': 'AudioObject',
      contentUrl: audioSurah.fullLink,
    },
  };
};

export default musicRecordingMarkupSchema;
